import React from "react";
import PropTypes from "prop-types";
import { ScrollPercentage } from "./ScrollyPercentage";
import { ScrollySlider } from "./ScrollySlider";
import { LanguageSwapper } from "./LanguageSwapper";
import i18n from "i18next";
import {
  appendUserSnapTestingScript,
  getMaxScrollHeight,
  getNewScrollPercentage,
  getScrollParams,
  throttle,
} from "./Scrolly.utlis";

import {
  NavigationBar,
  NavigationList,
  SlideController,
  FullPageScroll,
} from "@learningblocks/storybook-components";

import "./style.scss";

export class Scrolly extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      btnHover: [false, false, false, false],
      useCustomKeys: true,
      currentDescription: -1,
      isStopped: true,
      isPaused: true,
      percentage: 0,
      scrolled: 0,
      dragOffset: 0,
      data: [
        {
          id: null,
          description: "",
          minRange: null,
          maxRange: null,
        },
      ],
      objCurrent: null,
      objPrevious: null,
      scrolling: false,
      value: 4.5,
    };
  }

  updatePercentage = () => {
    const newScrollPercentage = getNewScrollPercentage();
    this.setState({
      percentage: newScrollPercentage,
    });
    // < 0 ? 0 : newScrollPercentage,
  };

  customScroll = (event) => {
    /* IE7, IE8, Chrome, Safari */
    if (!event) event = window.event;

    if (!this.state.scrolling) {
      if (event.deltaY > 0 || event.wheelDelta < 0 || event.detail > 0) {
        //scroll down
        this.onTabNext();
      } else {
        //scroll up
        this.onTabPrev();
      }
    }
  };

  scrollIndicator = (event) => {
    /* IE7, IE8, Chrome, Safari */
    if (!event) event = window.event;

    if (event.deltaY > 0 || event.wheelDelta < 0 || event.detail > 0) {
      //scroll down
      this.setState({
        btnHover: [true, false, false, false],
      });
    } else {
      //scroll up
      this.setState({
        btnHover: [false, false, false, true],
      });
    }
  };

  scrollListener = () => {
    throttle(this.updatePercentage);
  };

  componentDidMount() {
    appendUserSnapTestingScript();
    window.addEventListener("scroll", this.scrollListener, false);
    this.setNewDescriptionIndex();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener, false);
  }

  isPercentangeInComponentRange(componentRange) {
    return (
      this.state.percentage >= componentRange.minRange &&
      this.state.percentage <= componentRange.maxRange
    );
  }

  setNewDescriptionIndex = () => {
    const { components } = this.props.sceneData.Scrolly;
    if (components) {
      for (const index in components) {
        if (this.isPercentangeInComponentRange(components[index].props)) {
          this.setState({
            currentDescription: parseInt(index),
          });
          return;
        }
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.percentage !== prevState.percentage) {
      this.setNewDescriptionIndex();
    }
  }

  goToSection = (percentage) => {
    if (!this.state.scrolling) {
      const maxHeight = getMaxScrollHeight();
      const callback = () => {
        this.scrollTo((maxHeight * percentage) / 100, true);
      };
      this.setState({ scrolling: true }, callback);
    }
  };

  onTabNext = (jumpToSection) => {
    let newScrollValue = getMaxScrollHeight();
    const { components } = this.props.sceneData.Scrolly;
    this.setState({ scrolling: true }, () => {
      const maxIndex = components.length - 1;
      if (this.state.currentDescription < maxIndex) {
        const nextDescriptionMinRange =
          components[this.state.currentDescription + 1].props.minRange;
        newScrollValue = (newScrollValue * nextDescriptionMinRange) / 100;
      }
      this.scrollTo(newScrollValue, !!jumpToSection);
    });
  };

  onTabPrev = (jumpToSection) => {
    const maxHeight = getMaxScrollHeight();
    const { components } = this.props.sceneData.Scrolly;
    this.setState({ scrolling: true }, () => {
      let newScrollValue = 0;
      if (this.state.currentDescription >= 1) {
        const prevDescriptionMinRange =
          components[this.state.currentDescription - 1].props.minRange;
        newScrollValue = (maxHeight * prevDescriptionMinRange) / 100;
      }
      this.scrollTo(newScrollValue, !!jumpToSection);
    });
  };

  resetScrolling = () => {
    this.setState({ scrolling: false });
  };

  scrollTo = (scrollPoint, jumpToSection) => {
    const { currentTimeParam, start, change, duration, increment } =
      getScrollParams(scrollPoint);
    let currentTime = currentTimeParam;
    if (jumpToSection) {
      window.scrollTo(0, scrollPoint);
      this.resetScrolling();
    } else {
      const animateScroll = () => {
        currentTime += increment;
        const scrollValue = this.easeInOutQuad(
          currentTime,
          start,
          change,
          duration
        );

        window.scrollTo(0, Math.round(scrollValue));

        if (currentTime < duration) setTimeout(animateScroll, increment);
        else this.resetScrolling();
      };
      animateScroll();
    }
  };

  easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  setTotalHeight = (offset) => {
    this.setState({
      totalHeight: offset,
    });
  };

  handleChange = (event) => {
    this.setState({ value: event.target.valueAsNumber });
    this.updatePercentage();
  };

  render() {
    return (
      <div className="scrolly-wrap">
        <ScrollPercentage scrollValue={this.state.percentage} />
        <ScrollySlider
          slideValue={this.state.value}
          onChange={this.handleChange}
        />
        <NavigationBar>
          <NavigationList
            menuList={this.props.sceneData.Scrolly.customKeys}
            scrollTip={this.state.percentage}
            goToSection={this.goToSection}
          />
        </NavigationBar>
        <SlideController
          toPrevious={() => this.onTabPrev(true)}
          toNext={() => this.onTabNext(true)}
        />
        <FullPageScroll
          scrolling={this.state.scrolling}
          scrollTip={this.state.percentage}
          sceneData={this.props.sceneData}
          value={this.state.value}
          animationData={this.props.animationData}
          toPrevious={() => this.onTabPrev()}
          toNext={() => this.onTabNext()}
        />
        <LanguageSwapper
          languageList={["de", "en"]}
          onSelect={(language) => {
            i18n.changeLanguage(language);
          }}
        />
      </div>
    );
  }
}

Scrolly.propTypes = {
  /**
   * The animation data json
   */
  animationData: PropTypes.object.isRequired,
  /**
   * The data containing descriptions, list of navigation points to the animation
   */
  sceneData: PropTypes.shape({
    Scrolly: PropTypes.shape({
      customKeys: PropTypes.arrayOf(PropTypes.number),
      components: PropTypes.arrayOf(
        PropTypes.shape({
          component: PropTypes.string,
          props: PropTypes.object,
        })
      ),
    }),
  }).isRequired,
  /**
   * Url to usersnap
   */
  usersnap: PropTypes.string,
};

Scrolly.defaultProps = {
  animationData: {},
  sceneData: {
    Scrolly: {
      customKeys: [],
      components: {
        component: "",
        props: {},
      },
    },
  },
  usersnap: "",
};
